module.exports = "/_next/static/images/AggregationReverseETL-2a2fa7717a6b3037e2053fc88ca7d22f.webp";